<form #erzeugungsanlageForm="ngForm"
      data-qa="erzeugungsanlageDetailSummenerzeugerForm"
      fxLayout="column">
    @if (erzeugungsanlage) {
        <header>
            <div class="buttons"
            >
                <button [matButton]="readonly ? 'filled' : 'outlined'"
                        type="button"
                        class="actionbutton"
                        data-qa="close-details-button"
                        (click)="closeSideNav()">
                    <mat-icon svgIcon="innogy_picto_close"></mat-icon>
                    {{ (createNewMode || erzeugungsanlageForm.form.dirty) ? 'Abbrechen' : 'Schließen' }}
                </button>

                @if (!readonly) {
                    @if (!createNewMode) {
                        <button matButton="outlined"
                                type="reset"
                                data-qa="resetButton"
                                class="actionbutton"
                                (click)="resetForm()"
                                [disabled]="!erzeugungsanlageForm.form.dirty">
                            <mat-icon>autorenew</mat-icon>
                            Zurücksetzen
                        </button>
                    }
                    @if (!createNewMode) {
                        <button matButton="filled"
                                type="button"
                                class="actionbutton"
                                (click)="saveOrCreateErzeugungsanlage()"
                                data-qa="saveButton"
                                [disabled]="isSaveButtonDisabled()">
                            <mat-icon>save</mat-icon>
                            Speichern
                        </button>
                    }
                    @if (createNewMode) {
                        <button matButton="filled"
                                type="button"
                                color="primary"
                                class="actionbutton"
                                (click)="saveOrCreateErzeugungsanlage()"
                                data-qa="createButton"
                                [disabled]="isCreateButtonDisabled()">
                            <mat-icon>save</mat-icon>
                            Erstellen
                        </button>
                    }
                    @if (showDeleteButton) {
                        <button matButton="filled"
                                type="button"
                                data-qa="delete-erzeugungsanlage-button"
                                class="actionbutton button-warn"
                                (click)="deleteErzeugungsanlage()">
                            <mat-icon svgIcon="innogy_picto_bin_c-check"></mat-icon>
                            Löschen
                        </button>
                    }
                }
            </div>
            <div class="westnetzId">
                <div>Westnetz-ID:</div>
                <span class="westnetzId-title" data-qa="westnetzId">
        @if (!createNewMode) {
            <span>{{ erzeugungsanlage.westnetzId }}</span>
        }
                    @if (createNewMode) {
                        <span>wird automatisch gesetzt</span>
                    }
      </span>
            </div>
        </header>
        <div class="detail-main">
            <fieldset [disabled]="readonly">
                <legend> Basis-Daten</legend>
                <mat-form-field>
                    <mat-label>Primärenergieträger</mat-label>
                    <mat-select [(ngModel)]="erzeugungsanlage.anlagentyp"
                                [compareWith]="compareAnlagentyp"
                                data-qa="anlagentyp"
                                #anlagentyp="ngModel"
                                name="erzeugungsanlage_anlagentyp"
                                [disabled]="readonly"
                                required>
                        @for (anlagentyp of anlagentypen | async; track anlagentyp.nummer) {
                            <mat-option [value]="anlagentyp">
                                {{ anlagentyp.nummer }} {{ anlagentyp.name }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </fieldset>
            <fieldset [disabled]="readonly">
                <legend> Netzzuordnung</legend>
                <tnb-netzzuordnung-form #netzzuordnung="ngModel"
                                        [(ngModel)]="erzeugungsanlage.netzzuordnung"
                                        name="netzzuordnung"
                                        [disabled]="readonly"
                                        [stadtwerkeId]="stadtwerkeId">
                </tnb-netzzuordnung-form>
            </fieldset>
            <fieldset [disabled]="readonly">
                <legend> Leistungsdaten</legend>
                <mat-form-field>
                    <mat-label>Installierte Leistung</mat-label>
                    <input matInput
                           #installierteLeistungKW="ngModel"
                           data-qa="installierteLeistungKW"
                           pattern="[0-9]{0,6}"
                           [(ngModel)]="erzeugungsanlage.installierteLeistungKW"
                           id="installierteLeistungKW"
                           [disabled]="readonly"
                           [tnbResetAbregelbareLeistungErrorWhenInstallierteChanged]="abregelbareLeistungKW"
                           name="installierteLeistungKW"
                           required/>
                    <span matSuffix class="kw-suffix">kW (&#8721;)</span>
                    @if (installierteLeistungKW?.errors?.pattern || installierteLeistungKW?.errors?.required) {
                        <mat-error
                        >
                            Die installierte Leistung muss eine Ganzzahl zwischen 0 und 999999 kW (1GW) sein.
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Abregelbarer Anteil</mat-label>
                    <input matInput
                           #abregelbareLeistungKW="ngModel"
                           pattern="[0-9]{0,6}"
                           data-qa="abregelbareLeistungKW"
                           [(ngModel)]="erzeugungsanlage.abregelbareLeistungKW"
                           [disabled]="readonly"
                           [tnbAbregelbareLeistungLowerThanInstallierte]="installierteLeistungKW.value"
                           name="abregelbareLeistungKW"
                           required/>
                    <span matSuffix class="kw-suffix">kW (&#8721;) </span>
                    @if (abregelbareLeistungKW?.errors?.abregelbareLeistungLowerEqualsInstallierte) {
                        <mat-error>
                            Die abregelbare Leistung darf nicht größer sein als die installierte
                        </mat-error>
                    }
                    @if (abregelbareLeistungKW?.errors?.pattern || abregelbareLeistungKW?.errors?.required) {
                        <mat-error
                        >
                            Die abregelbare Leistung muss eine Ganzzahl zwischen 0 und 999999 kW (1 GW) sein
                        </mat-error>
                    }
                </mat-form-field>
            </fieldset>
        </div>
    }
</form>
